/**
* Service for premium features (e.g. subscriptions, paid links etc.)
*/
import type {
  IPaidLinks,
} from "../types";

import type { ApiClient } from "@/common/api/http/types";

export default class PremiumService {
  public constructor(private readonly client: ApiClient) {}

  async getPaidLinks(): Promise<IPaidLinks> {
    return await this.client.get("/v2/premium/paid-links");
  }
}
